import { Backdrop, Switch } from '@mui/material';
import styled from 'styled-components';

const SettingsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing(2)};
`;

const DarkModeSwitch = styled(Switch)`
    margin-left: ${({ theme }) => theme.spacing(2)};
    margin-right: ${({ theme }) => theme.spacing(2)};
`;

const DarkModeSettingContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

const StyledBackdrop = styled(Backdrop)`
    z-index: ${({ theme }) => theme.zIndex.drawer + 1};
`;

export { SettingsContainer, StyledBackdrop, DarkModeSwitch, DarkModeSettingContainer };
